export default __webpack_public_path__ + "static/media/defense.e7b2c2e6.webp";